export default "__VITE_ASSET__e33cb63f__"